
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/myrooms",
      function () {
        return require("private-next-pages/myrooms.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/myrooms"])
      });
    }
  